import { gql } from "apollo-angular";
import { CBFF } from "./content-block-full"
import { DIF } from "./disclaimer-item"

export const FAF = gql`
  fragment FAF on FaqAccordion {
    backgroundColor {
      color
    }
    header
    headerTag
    hTagId
    content
    faqListCollection (limit: 13) {
      items {
        header
        hTag
        hTagId
        content
        faqBlocksCollection (limit: 25) {
            items {
              hTag
              hTagId
              question
              answer
              showSchema
            }
        }
      }
    }
    rightRailContentCollection (limit: 4) {
      items {
        ...CBFF
      }
    }
    disclaimer {
      ... DIF
    }
  }
 ${DIF}
 ${CBFF}`;
